import React, { useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import ReceiptPreview from './ReceiptPreview';
import { humaniseError } from '../printing/qzPrinting';
import { RECEIPT_PRINTER, printReceipt, receiptFields } from '../printing/receipt';

/**
 * "Do you want to print?" — the receipt, with a preview of it.
 *
 * The receipt itself is built in containers/printing/receipt.js, because it is
 * printed from two places now: this button, and automatically when the
 * business is set to auto-print. Both use the same builder, so the copy that
 * comes out on its own is the copy a cashier would have seen here.
 */
const PrinterOrder = ({ open, onClose, business, user, data }) => {
  const [printing, setPrinting] = useState(false);

  // The preview and the paper are drawn from one object; what is on screen is
  // what comes out of the printer.
  const fields = receiptFields({ business, data });

  // Payment numbers the preview shows but the printed receipt does not — the
  // printed one uses the business's own paytoAccounts.
  const evcNumber = '615753832';
  const edahabNumber = '625753832';
  const merchantNumber = '59849464';

  const handlePrint = async () => {
    try {
      setPrinting(true);
      await printReceipt({ business, data });
      onClose();
    } catch (error) {
      console.error('PRINT ERROR', error);
      alert(
        'Could not print the receipt.\n\n' +
          humaniseError(error, { name: RECEIPT_PRINTER })
      );
    } finally {
      setPrinting(false);
    }
  };

  // =========================================
  // MODAL
  // =========================================

  return (

    <Modal
      open={open}
      onClose={onClose}
    >

      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',

          width: 450,

          maxHeight: '90vh',

          bgcolor: 'background.paper',

          border: '2px solid #000',

          boxShadow: 24,

          overflow: 'hidden',

          display: 'flex',

          flexDirection: 'column',
        }}
      >

        {/* =================================
            TITLE
        ================================= */}

        <Typography
          variant="h6"
          sx={{
            p: 2,
            pb: 1,
            flexShrink: 0
          }}
        >
          Do you want to print?
        </Typography>


        {/* =================================
            RECEIPT PREVIEW
        ================================= */}

        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            minHeight: 0
          }}
        >

          <ReceiptPreview
            businessName={fields.businessName}
            businessLocation={fields.businessLocation}
            businessNumber={fields.businessNumber}
            paytoaccounts={fields.paytoAccounts}
            evcNumber={evcNumber}
            edahabNumber={edahabNumber}
            merchantNumber={merchantNumber}
            orderNumber={fields.orderNumber}
            waiterName={fields.waiterName}
            formattedDate={fields.formattedDate}
            formattedTime={fields.formattedTime}
            products={fields.products}
            total={fields.total}
            vatRate={fields.vatRate}
            vatAmount={fields.vatAmount}
            grandTotal={fields.grandTotal}
          />

        </Box>


        {/* =================================
            BUTTONS
        ================================= */}

        <Box
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
            flexShrink: 0,
            borderTop: '1px solid #ddd'
          }}
        >

          <Button
            style={{
              background: '#F64829'
            }}
            variant="contained"
            disabled={printing}
            onClick={handlePrint}
          >

            {printing
              ? 'PRINTING...'
              : 'Print Order'}

          </Button>


          <Button
            variant="contained"
            style={{
              background: 'white',
              color: 'black'
            }}
            disabled={printing}
            onClick={onClose}
          >

            Cancel

          </Button>

        </Box>

      </Box>

    </Modal>

  );

};

export default PrinterOrder;